import { useState } from "react";
import { usePostOutboundCallMutation } from "../../../store/reservations/reservationsApi";
import { IToast } from "../../../interfaces/components/IToast";
import Toast from "../../../shared/toast";
import Loading from "../../../shared/Loading";

const MakeCall = ({
  customer,
  phoneNumber,
}: {
  customer: string;
  phoneNumber: string;
}) => {
  const [showToast, setShowToast] = useState<IToast | null>();
  const [outboundCall, { isLoading }] = usePostOutboundCallMutation();

  const handleCall = async () => {
    try {
      await outboundCall({
        phoneNumber,
        customer,
      }).unwrap();
      setShowToast({
        type: "success",
        message: "The outbound call has been successfully completed",
      });
    } catch (e) {
      setShowToast({ type: "error", message: "Cannot make outbound call" });
    }
  };
  return (
    <>
      <button
        className=""
        onClick={handleCall}
        type="button"
      >
        {isLoading ? (
          <Loading />
        ) : (
          <div className="flex items-center bg-call-default hover:bg-call-hover  pr-8 p-2 rounded">
            <img src="/assets/shared/call.svg" alt="call" />
            <span className="ml-2">Call</span>
          </div>
        )}
      </button>
      {showToast?.message && (
        <Toast
          type={showToast?.type}
          text={showToast?.message}
          onHandleCloseToast={() => setShowToast(null)}
        />
      )}
    </>
  );
};

export default MakeCall;
